/**
 * Where the company-management portal lives.
 *
 * The portal is served by the same bundle as the customer app, but only on ONE dedicated hostname
 * (`manage.<APP_DOMAIN>` by default), where `App` renders `PlatformPortalApp` instead of the
 * customer app. Customer hostnames never render it. The hostname keeps the two surfaces apart; the
 * protection is server-side: every portal API call requires `authenticatePlatformAdmin`.
 *
 * Both values are baked in at build time, like `VITE_APP_DOMAIN` (see subdomain.ts):
 *   VITE_PLATFORM_HOST_LABEL     the subdomain label (default `manage`; also reserved in
 *                                @hrms/shared so no company can register it as a workspace)
 *   VITE_PLATFORM_HOME_ORG_SLUG  the company the platform owner signs in through: `auth.login`
 *                                always names a company, and a platform owner has none of their own
 */

import { APP_DOMAIN } from './subdomain.js';

export const PLATFORM_HOST_LABEL: string = import.meta.env.VITE_PLATFORM_HOST_LABEL ?? 'manage';
export const PLATFORM_HOME_ORG_SLUG: string =
  import.meta.env.VITE_PLATFORM_HOME_ORG_SLUG ?? 'arhamfintech';

export function isPlatformHost(): boolean {
  return window.location.hostname.toLowerCase() === `${PLATFORM_HOST_LABEL}.${APP_DOMAIN}`;
}

/** The portal's origin, for a link out of the customer app. */
export function platformPortalOrigin(): string {
  const port = window.location.port ? `:${window.location.port}` : '';
  return `${window.location.protocol}//${PLATFORM_HOST_LABEL}.${APP_DOMAIN}${port}`;
}
